"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Textarea = props => {
  const {
    label,
    rows,
    onChange,
    error,
    errorMessage
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-form-group"
  }, /*#__PURE__*/_react.default.createElement("label", {
    for: "message",
    className: "con-form-group__label"
  }, label), /*#__PURE__*/_react.default.createElement("textarea", {
    rows: rows,
    className: "con-form-goup__textarea".concat(error ? ' con-form-group__textarea--error' : ''),
    name: "Name",
    id: "message",
    onChange: onChange
  }), error ? /*#__PURE__*/_react.default.createElement("p", {
    className: "con-error"
  }, errorMessage) : '');
};
Textarea.propTypes = {
  label: _propTypes.default.string,
  rows: _propTypes.default.string,
  onChange: _propTypes.default.func,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string
};
var _default = exports.default = Textarea;